import React from "react";
import whiteStars from "../../../../../../assets/white_stars.png";
import superheroFilled from "../../../../../../assets/superhero_filled.png";

const NarrativeCompletionCard = ({
  heroTitle = "Dependable Hero",
  heroSubtitle = "Build trust through steady presence and risk reduction.",
  bullets = [],
}) => (
  <div
    className="flex flex-col items-center overflow-hidden relative"
    style={{
      width: 427,
      height: 567,
      borderRadius: 24,
      background: "#fff",
    //   border: "1px solid",
      borderImage: "linear-gradient(161.13deg, #D9D9D9 -6.67%, #707070 90.21%) 1",
      boxShadow: "0px 10px 74px 0px #00000033"
    }}
  >
    {/* Title bar */}
    <div className="w-full flex flex-row items-center justify-center relative"
      style={{ height: 120, background: "#17A5A3" }}>
      {/* Left Star */}
      <img
        src={whiteStars}
        alt="star"
        className="object-contain"
        style={{
          width: 30.2,
          height: 32,
          marginRight: 28,
          opacity: 1,
          transform: "rotate(-180deg)"
        }}
      />
      {/* Text */}
      <div className="flex flex-col items-center">
        <span
          className="uppercase font-bold text-center"
          style={{
            fontFamily: "Gotham,sans-serif",
            fontWeight: 700,
            fontSize: "23.33px",
            color: "#fff",
            lineHeight: "135%",
            letterSpacing: 0,
            marginBottom: -2,
          }}
        >
          MY BRAND
        </span>
        <span
          className="uppercase font-bold text-center"
          style={{
            fontFamily: "Gotham,sans-serif",
            fontWeight: 700,
            fontSize: "23.33px",
            color: "#fff",
            lineHeight: "135%",
            letterSpacing: 0,
          }}
        >
          NARRATIVE
        </span>
      </div>
      {/* Right Star */}
      <img
        src={whiteStars}
        alt="star"
        className="object-contain"
        style={{
          width: 30.2,
          height: 32,
          marginLeft: 28,
          opacity: 1
        }}
      />
    </div>

    {/* Main Card content */}
    <div className="flex flex-col items-center w-full px-12 pt-4" style={{ flex: 1 }}>
      {/* Hero image */}
      <div className="flex items-center justify-center mx-auto" style={{ width: 84.41, height: 98.52 }}>
        <img src={superheroFilled} alt="Hero" className="object-contain"
          style={{ width: 84.41, height: 98.52 }} />
      </div>

      <div
        className="font-bold text-center"
        style={{
          fontFamily: "Gotham,sans-serif",
          fontWeight: 500,
          fontSize: "24px",
          color: "#0E918F",
        }}>
        {heroTitle}
      </div>

      <div
        className="text-center mx-4"
        style={{
          fontFamily: "Gotham,sans-serif",
          fontWeight: 400,
          fontSize: "16px",
          color: "#000000",
          
        }}>
        {heroSubtitle}
      </div>
      <div
        className="font-semibold text-center my-2"
        style={{
          fontFamily: "Gotham,sans-serif",
          fontWeight: 500,
          fontSize: "16px",
          color: "#000000",
          margin: "30px 0 10px 0",
        }}>
        KEY TACTICS
      </div>
      <ul className="w-full list-none p-0 m-0">
        {bullets.map((b, idx) => (
          <li key={idx} className="flex items-center gap-2 mb-2.5">
           <span className="inline-flex items-center justify-center" style={{ width: 16, height: 16 }}>
            <svg width={16} height={16} fill="none">
                <circle cx="8" cy="8" r="8" fill="#000000" />
                <path
                d="M4 8.5l3 3 5-5"
                stroke="#fff"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                />
            </svg>
            </span>

            <span className="text-base" style={{
              fontFamily: "Gotham,sans-serif",
              fontWeight: 400,
              fontSize: 14,
              color: "#000000"
            }}>
              {b}
            </span>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default NarrativeCompletionCard;